export default __webpack_public_path__ + "static/media/puesto.0b2b7f13.png";